import { HelpContent } from '../UI-Lib/Help-Tooltip';


export const MOVE_COPY_HELP: HelpContent[] = [
    {
        helpContentId: 'move.copy-csrmode',
        tooltipText: 'This controls how already created tasks on the source entity will be treated during the requested operation. '
            + ' CSR themselves will not be modified at the source or destination.  The following applies to open tasks only. '
            + ' Always Preserve Existing means no changes will be made (default) '
            + 'Preserve Overridden Only means tasks with overridden assignments will remain unchanged, but all others will be updated to the destination\'s CSR config. '
            + ' Assume Destination means that all tasks will be updated to match the destination\'s current CSR configuration. '
            + ' Future tasks will follow the CSR configuration of the entity at the time of creation.',
        hasIcon: true
    }
];
